import React from 'react';
import { Modal } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { globalConst, onTrackYandexGoal, setLimitOpen, useUnixCountdown } from 'modules/global';

export const LimitFinishedModal: React.FC = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const open = useAppSelector(({ limitFinishedModal }) => limitFinishedModal.open);
  const nextOpenTime = useAppSelector(({ limitFinishedModal }) => limitFinishedModal.nextOpenTime);
  const { hours, minutes, seconds } = useUnixCountdown(nextOpenTime);

  const format = (num: number) => String(num).padStart(2, '0');

  const onClose = () => {
    dispatch(setLimitOpen({ open: false }));
  };

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onCancel={onClose}
      closable={false}
      width="26rem"
      styles={{
        content: { padding: '12px', borderRadius: '12px' }
      }}
    >
      <div className="sm:h-63 relative h-60 w-full">
        <Image fill src="/images/limit-modal.webp" alt="Limit modal pro image" title="Limit tugadi" />
      </div>
      <div className="mt-5">
        <div className="text-center text-xl font-semibold">{t('kunlik_limitiz_tugadi')}</div>
        <p className="mt-3 text-center text-xs text-gray-600">{t('kunlik_limitiz_tugadi_des')}</p>

        <div className="mt-4 flex items-center justify-center">
          <div className="flex items-center gap-3 rounded-lg bg-red-100 px-3 py-1.5 backdrop-blur-lg">
            <div className="flex items-center space-x-1">
              <div className="rounded-md bg-white px-2 py-1 text-xs font-semibold text-red-600">{format(hours)}</div>
              <span>:</span>
              <div className="rounded-md bg-white px-2 py-1 text-xs font-semibold text-red-600">{format(minutes)}</div>
              <span>:</span>
              <div className="rounded-md bg-white px-2 py-1 text-xs font-semibold text-red-600">{format(seconds)}</div>
            </div>
            <p className="text-xs font-medium text-gray-800">{t('dan_keyin_ochiladi')}</p>
          </div>
        </div>
        <div className="mt-5 flex items-center gap-3">
          <button onClick={onClose} className="h-11.5 w-full cursor-pointer rounded-lg bg-gray-100 text-sm font-medium">
            {t('keyinroq')}
          </button>
          <Link
            href={globalConst.pageNames.PRO}
            onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.limit_finished_pro)}
            className="h-11.5 flex w-full items-center justify-center rounded-lg !bg-green-500 text-sm font-medium !text-white"
          >
            {t('obuna_bolish')}
          </Link>
        </div>
      </div>
    </Modal>
  );
};
